import { GreaterThanEqual, LessThanEqual } from '@boxicons/react';
import { XIcon } from '../../../components/shared/icons';

interface Props {
    label: string;
    min?: number;
    max?: number;
    onRemove: () => void;
}

export function RangeFilterLabel({ label, min, max, onRemove }: Props) {
    if (min === undefined && max === undefined) return;

    return (
        <button
            type='button'
            aria-label={`Remove ${label} filter`}
            className='bg-theme-500 ps-2 pe-1 py-0.5 round:rounded-md border border-theme-400 hover:border-red-500 group slow-effect-transition flex items-center gap-1 shrink-0 whitespace-nowrap capitalize'
            onClick={onRemove}
        >
            <span>{label}:</span>
            {min && max ? (
                `${min} - ${max}`
            ) : !min ? (
                <span className='flex items-center'>
                    <LessThanEqual size='xs' /> <span className='ms-0.5'>{max}</span>
                </span>
            ) : (
                <span className='flex items-center'>
                    <GreaterThanEqual size='xs' /> <span className='ms-0.5'>{min}</span>
                </span>
            )}{' '}
            <span aria-hidden className='group-hover:text-red-500 slow-effect-transition'>
                <XIcon size={18} />
            </span>
        </button>
    );
}
